<template>
  <div class="tile">
    <p class="content__heading">{{website.name}}</p>
    <simplebar class="website--overflow" data-simplebar-auto-hide="false">
      <div class="website--links">
        <div v-if="website.forms && website.forms.length > 0">
          <p class="text__bold text__center">Online Forms</p>
          <WebForm
            v-for="form in website.forms"
            :key="form.id"
            :form="form"
            :copied="copied"
            @copyText="handleCopyText"
          />
        </div>
        <div v-if="website.pages && website.pages.length > 0">
          <p class="text__bold text__center">Policy Pages</p>
          <WebPage
            v-for="page in website.pages"
            :key="page.id"
            :page="page"
            :copied="copied"
            @copyText="handleCopyText"
          />
        </div>
      </div>
    </simplebar>
  </div>
</template>

<script>
import WebForm from "./WebForm";
import WebPage from "./WebPage";
export default {
  props: ["website"],
  components: {
    WebForm,
    WebPage
  },
  data() {
    return {
      copied: ""
    };
  },
  methods: {
    handleCopyText(id) {
      const input = document.getElementById(id);
      input.select();
      input.setSelectionRange(0, 99999);

      document.execCommand("copy");
      this.copied = id;
      setTimeout(this.clearCopy, 1000);
    },
    clearCopy() {
      return (this.copied = false);
    }
  }
};
</script>

<style scoped>
</style>